import { render, staticRenderFns } from "./AlertaModal.vue?vue&type=template&id=0e019f83&scoped=true"
import script from "./AlertaModal.vue?vue&type=script&lang=js"
export * from "./AlertaModal.vue?vue&type=script&lang=js"
import style0 from "./AlertaModal.vue?vue&type=style&index=0&id=0e019f83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e019f83",
  null
  
)

export default component.exports